import Subscriber from '@libs/Subscriber';
import ActiveState from '@libs/ActiveState';

class FolderService extends Subscriber {
  active = new ActiveState();
  current = new ActiveState();
}

export default new FolderService();
